module.exports = __webpack_public_path__ + "assets/img/img260.505a5def.png";